const DEFAULT_DECIMAL_SEPARATOR = '.';
const DEFAULT_THOUSAND_SEPARATOR = ',';
const DEFAULT_DECIMAL_PRECISION = 2;

const optionsDefault = {
	decimalSeparator: DEFAULT_DECIMAL_SEPARATOR,
	thousandSeparator: DEFAULT_THOUSAND_SEPARATOR,
	decimalPrecision: DEFAULT_DECIMAL_PRECISION,
};

class FormOptions {
	constructor() {
		this.options = { ...optionsDefault };
	}

	set(options) {
		this.options = { ...this.options, ...options };
	}

	get(property) {
		return this.options[property];
	}
}

const formOptions = new FormOptions();

export default formOptions;
